import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { GenericButton } from "shared/ui-basics/buttons";
import { FlexAlignCenter, FlexBetweenAlignCenter, IconDispatcher } from "shared/ui-basics/index";
import StatusItem from "shared/ui-basics/ui-components/StatusItem";
import { Badge, BadgeWrapper, RemoveButton } from "./PicklistCard_style";
import { InformationType } from "utils/optionsSets/OptionSets";
import { FindStatusById } from "redux/memoizedSelectors";
import { useTranslation } from "react-i18next";

export const ProjectItemCard = ({ index, entity, unlink, recordId, disable }) => {
	const history = useHistory();
	const { t } = useTranslation();
	const allProjects = useSelector((state) => state.projects.all_projects);
	const currentEntity = entity || allProjects?.find((sol) => sol.id === recordId);
	const statusId = currentEntity?.attributes?.find((attr) => attr.type === InformationType.Status)?.statusId;
	const status = useSelector(FindStatusById("project", statusId));

	if (!currentEntity) return <Badge key={entity?.id} id={entity?.id} disabled={true}>
		<BadgeWrapper index={index} length={length}  >
			{t("NO_ACCESS")}
		</BadgeWrapper>
	</Badge>
	const handleClick = (e) => {
		e.stopPropagation();
		history.push(`/EditProject?id=${currentEntity?.id}`)
	}
	const handleRemove = (e) => {
		e.stopPropagation();
		e.preventDefault();

		unlink(currentEntity?.id);
	}
	return (
		<Badge key={currentEntity?.id} id={currentEntity?.id}>
			<BadgeWrapper index={index} >
				<FlexAlignCenter>
					{IconDispatcher("PROJECT", "border border-dark rounded-circle p-1 me-2")}
					<div className="ellipsis obj-name px-2" onClick={handleClick}title={currentEntity?.name}>
						{currentEntity?.name?.defaultPlaceholder("PROJECT_NAME")}
					</div>
				</FlexAlignCenter>
				<FlexBetweenAlignCenter className="px-2" minWidth='170px'>
					<div><StatusItem status={status} /></div>
					{!disable && (
						<RemoveButton>
							<GenericButton variant="light-link" id={currentEntity?.id} icon="X"  size='xs' className="p-0" iconClassName="p-0" onClick={handleRemove} />
						</RemoveButton>
					)}
				</FlexBetweenAlignCenter>
			</BadgeWrapper>

		</Badge>
	);
};

